require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bic-calls-on-climate-envoy-john-kerry-to-end-public.json") })
        }
      }, "path---en-us-update-bic-calls-on-climate-envoy-john-kerry-to-end-public");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bic-calls-on-climate-envoy-john-kerry-to-end-public!./.cache/json/en-us-update-bic-calls-on-climate-envoy-john-kerry-to-end-public.json
// module id = 623
// module chunks = 231608221292675